module.exports = __webpack_public_path__ + "static/IMG_7886-0b37a4acb45ffb2ed5fbf6719eae654f.jpg";